import React from "react";
import { ColorIconProps, getColorIconSize } from "./utils";

const SystematicReviewIcon: React.FC<ColorIconProps> = ({
  size = "default",
  className,
}) => {
  return (
    <svg
      width={getColorIconSize(size)}
      height={getColorIconSize(size)}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M16.7072 2.07031H3.29283V18.1675H16.7072V2.07031Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5 2.07029C17.5 1.63243 17.145 1.27747 16.7072 1.27747H3.29283C2.85496 1.27747 2.5 1.63243 2.5 2.07029V18.1675C2.5 18.6054 2.85496 18.9603 3.29283 18.9603H16.7072C17.145 18.9603 17.5 18.6054 17.5 18.1675V2.07029ZM15.9143 2.86312V17.3747H4.08565V2.86312H15.9143Z"
        fill="currentColor"
      />
      <path
        d="M16.7072 1.62622H3.29283V16.707H16.7072V1.62622Z"
        fill="var(--cdl-bg-faint)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5 1.6262C17.5 1.18833 17.145 0.833374 16.7072 0.833374H3.29283C2.85496 0.833374 2.5 1.18833 2.5 1.6262V16.707C2.5 17.1449 2.85496 17.4998 3.29283 17.4998H16.7072C17.145 17.4998 17.5 17.1449 17.5 16.707V1.6262ZM15.9143 2.41902V15.9142H4.08565V2.41902H15.9143Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.8717 4.66844C13.8717 4.23057 13.5167 3.87561 13.0788 3.87561H6.92115C6.48329 3.87561 6.12833 4.23057 6.12833 4.66844C6.12833 5.1063 6.48329 5.46126 6.92115 5.46126H13.0788C13.5167 5.46126 13.8717 5.1063 13.8717 4.66844Z"
        fill="var(--cdl-chart-green-base)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.8717 7.3513C13.8717 6.91343 13.5167 6.55847 13.0788 6.55847H6.92115C6.48329 6.55847 6.12833 6.91343 6.12833 7.3513C6.12833 7.78916 6.48329 8.14412 6.92115 8.14412H13.0788C13.5167 8.14412 13.8717 7.78916 13.8717 7.3513Z"
        fill="var(--cdl-chart-green-base)"
      />
      <path
        d="M10.0001 9.46875L9.30415 11.1016L7.53615 11.2589L8.87406 12.4253L8.47728 14.1554L10.0001 13.2434L11.5229 14.1554L11.1261 12.4253L12.464 11.2589L10.696 11.1016L10.0001 9.46875Z"
        fill="var(--cdl-chart-green-base)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0001 8.67603C9.68233 8.67603 9.39529 8.86572 9.27071 9.15801L8.76096 10.3541L7.4659 10.4693C7.14941 10.4974 6.88031 10.7118 6.78212 11.014C6.68394 11.3162 6.77564 11.6478 7.01513 11.8566L7.99515 12.711L7.70451 13.9783C7.63349 14.288 7.75421 14.6102 8.01127 14.7969C8.26832 14.9837 8.61204 14.9989 8.88463 14.8357L10.0001 14.1677L11.1155 14.8357C11.3881 14.9989 11.7318 14.9837 11.9889 14.7969C12.2459 14.6102 12.3666 14.288 12.2956 13.9783L12.005 12.711L12.985 11.8566C13.2245 11.6478 13.3162 11.3162 13.218 11.014C13.1198 10.7118 12.8507 10.4974 12.5342 10.4693L11.2392 10.3541L10.7294 9.15801C10.6048 8.86572 10.3178 8.67603 10.0001 8.67603ZM10.0001 11.4816C10.114 11.6904 10.316 11.8371 10.5498 11.881C10.3864 12.0538 10.3092 12.2913 10.3398 12.5272C10.1249 12.4252 9.87521 12.4252 9.66033 12.5272C9.6909 12.2913 9.61373 12.0538 9.45037 11.881C9.68413 11.8371 9.88615 11.6904 10.0001 11.4816Z"
        fill="var(--cdl-chart-green-base)"
      />
    </svg>
  );
};

export default SystematicReviewIcon;
